module.exports = __webpack_public_path__ + "static/media/info.47088943.svg";